module.exports = __webpack_public_path__ + "img/product-core-6.c15e2621.png";